var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"top-nav"},[_c('div',[_c('nav-common',{attrs:{"nav":_vm.nav}})],1)]),_vm._v(" "),_c('div',{staticClass:"detail"},[_c('item-detail',{attrs:{"detail":_vm.detail}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78d15204","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/ComParty/detail.vue
// module id = null
// module chunks = 